((($) => {
    const burgerMenu = $('#burger-menu');
    const burgerMenuWrapper = $('.mobile-main-menu-wrapper,.mobile-portal-main-menu-wrapper');
    const toggleBurgerMenu = (status) => {

        if (status === true) {
            burgerMenu.addClass('open');
            burgerMenuWrapper.addClass('is-open');
        } else {
            burgerMenu.removeClass('open');
            burgerMenuWrapper.removeClass('is-open');

        }
    }

    burgerMenu.on('click', function (e) {
        e.preventDefault();
        toggleBurgerMenu(!burgerMenu.hasClass('open'));
    })
})(jQuery));
